import PropTypes from 'prop-types';

const defaultTitle = 'Privatlivspolitik | Svanes Dyr ';
const defaultDescription = 'Svanes Dyr - Privatlivspolitik';
const defaultKeywords = `Svaens Dyr privatlivspolitik,`;

const MetaLawPrivate = ({
  title = defaultTitle,
  description = defaultDescription,
  keywords = defaultKeywords,
}) => (
  <>
    <title>{title}</title>
    <meta property="og:title" content={title} />
    <link rel="canonical" href="https://www.svanesdyr.dk/privatlivspolitik" />
    <meta property="og:url" content="https://www.svanesdyr.dk/privatlivspolitik" />

    <meta property="og:locale" content="da_DK" />
    <meta property="og:type" content="website" />
    <meta property="og:image" content="https://www.svanesdyr.dk/MetaLaw.png" />
    <meta property="og:site_name" content="Svanes Dyr" />

    <meta name="keywords" content={keywords} />
    <meta name="description" content={description} />
    <meta property="og:description" content={description} />
  </>
);

MetaLawPrivate.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
};

export default MetaLawPrivate;
